import React, { Component, useState } from "react";
import $ from 'jquery';
import { fabric } from 'fabric';
import {
  PdfLoader,
  PdfHighlighter,
  Tip,
  Highlight,
  Popup,
  AreaHighlight,
} from "./react-pdf-highlighter";
import axios from '../../redux/axios';

import type { IHighlight, NewHighlight } from "./react-pdf-highlighter";
import { Link, useHistory, useLocation, Redirect, withRouter } from "react-router-dom";
import { testHighlights as _testHighlights } from "./test-highlights";
import { Spinner } from "./Spinner";
import { Sidebar } from "./Sidebar";
import { Layout, Menu, Card, Row, Col, Divider, Table, Spin, Button, Space, message, Modal, Select, Upload, Tooltip, Tabs,  Image, Input, notification } from 'antd';
import Container from '../Layout/Container';
import {
  LeftOutlined,
  RightOutlined,
  LoadingOutlined,
  SyncOutlined,
  CloseOutlined,
  EditOutlined
} from "@ant-design/icons";
import { pdfjs } from 'react-pdf';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import {
  DownloadOutlined,
  PrinterOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import "./style/App.css";
import { FaSignature } from 'react-icons/fa';
import { connect } from 'react-redux';
import ability from '../../config/ability';
import { getOcr, getDocumentHighlights, AddHighlightsAsyn, getIncryptedPDF, EncrptyPdfDataDelAsyn, DocumentHighlightsSelector, clearAddResponseState as ClearAddHighlightState, getDocumentDetailAsyn, getDocumentDetailV2Asyn, unsetDocumentDetailStateAsync, pdfNewProcessAsyn } from './DocumentHighlightsSlice';
import { getDocumentComments } from '../DocumentComments/DocumentCommentsSlice';
import history from "../../history";
import { createBrowserHistory } from "history";
// import * as PDFJSViewer from "pdfjs-dist/legacy/web/pdf_viewer";
// import { getDocument } from "pdfjs-dist/legacy/build/pdf.js";
pdfjs.GlobalWorkerOptions.workerSrc = `pdf.worker-2.9.359.min.js`;
const { Header, Content, Footer, Sider } = Layout;
const testHighlights: Record<string, Array<IHighlight>> = _testHighlights;
const { TabPane } = Tabs;
const { TextArea } = Input;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
//to be deleted


console.log(getDocumentHighlights,"ALLMESSAGE");
interface State {
  url: string;
  highlights: Array<IHighlight>;
  esignImage: string;
  isShowpdfColumn: boolean;
  seenStamp: boolean;
  pdfDOc: any;
  isLoading: boolean;
  pdfInfo: any;
  checkDrcptyPdf: boolean;
  btnDisable: boolean,
  isModalOpen:boolean,
  isTitleModalOpen:boolean,
  isModal1Open:boolean,
  pdfNum:string,
  hgTitle:string,
  ocrContent:string,
  ocrLoaded: boolean,
  highlightedText:string,
  // AddHighlightsAsyn: any;
  // clearAddResponseState: any;
}

// interface DispatchProps {
//   AddHighlightsAsyn: () => void,
//   clearAddResponseState: () => void
// }

// interface OwnProps {

// }

// type Props = State & DispatchProps & OwnProps

let fabricjs: any = fabric;
// interface freeDrawingBrush {
//   width: number;
//   color: string;
// };


const getNextId = () => String(Math.random()).slice(2);

const parseIdFromHash = () =>
  document.location.hash.slice("#highlight-".length);

const resetHash = () => {
  document.location.hash = "";
};

const HighlightPopup = ({
  comment,
}: {
  comment: { text: string; emoji: string };
}) =>
  comment.text ? (
    <div className="Highlight__popup">
      {comment.emoji} {comment.text}
    </div>
  ) : null;


const { documentInfo }: any = history.location.state ? history.location.state : '';

//console.log(documentInfo.documentUpdatedData.processTimeLogs[0].pdfFile);
// const PRIMARY_PDF_URL = localStorage.getItem('PRIMARYPDFURL')?localStorage.getItem('PRIMARYPDFURL'):history.location.state?documentInfo.documentUpdatedData.processTimeLogs[0].pdfFile:'';
//   const PRIMARY_PDF_URL = history.location.state?documentInfo.documentUpdatedData.processTimeLogs[0].pdfFile:'';
//   console.log('documentInfo')
// console.log(documentInfo)
//  //const PRIMARY_PDF_URL = "naa_form.pdf";
// const SECONDARY_PDF_URL = "naa_form.pdf";

let number_of_pages = 0;
let pages_rendered = 0;
let active_tool = 1; // 1 - Free hand, 2 - Text, 3 - Arrow, 4 - Rectangle
let fabricObjects: any[] = [];
let fabricObjectsData: any[] = [];
let color = '#212121';
let borderColor = '#000000';
let borderSize = 1;
let font_size = 16;
let active_canvas = 0;
let container_id = 'pdfViewer';
let options = {};

// const searchParams = new URLSearchParams(document.location.search);

// const initialUrl = searchParams.get("url") || PRIMARY_PDF_URL;

// export interface IProps {getDocumentDetailAsyn: Function, Items:any[]} 

export interface IProps {
  getDocumentDetailAsyn: Function,
  getDocumentDetailV2Asyn: Function,
  documentDetailData: any,
  history: any,
  location: any,
  getDocumentHighlights: Function,
  getOcr: Function,
  
  documentData: any[],
  AddHighlightsAsyn: Function,
  getIncryptedPDF: Function,
  EncrptyPdfDataDelAsyn: Function,
  ClearAddHighlightState: Function,
  unsetDocumentDetailStateAsync: Function,
  pdfNewProcessAsyn: Function,

}

// class DocumentVerification extends Component<{history:any}, State> {
class DocumentVerification extends Component<IProps, State> {
  viewer: PdfLoader | null | undefined;
  pdfhighlightRef: any;
  pdfjslibRef: any;
  sigPad: any;

  constructor(props: any) {
    super(props);
    this.state = {
      url: '',
      // highlights: testHighlights[initialUrl]
      //   ? [...testHighlights[initialUrl]]
      //   : [],
      highlights: [],
      esignImage: '',
      isShowpdfColumn: true,
      seenStamp: props.location.state ? props.location.state.documentInfo.documentUpdatedData.seenStamp : false,
      // seenStamp:history.location.state?documentInfo.documentUpdatedData.seenStamp:false,
      pdfDOc: null,
      isLoading: false,
      pdfInfo: null,
      checkDrcptyPdf: false,
      btnDisable: false,
      isModalOpen:false,
      pdfNum:"1",
      hgTitle:'Note this',
      isModal1Open:false,
      isTitleModalOpen:false,
      ocrContent: '...kindly wait. Content Loading.',
      ocrLoaded: false,
      highlightedText:'',
    };
    this.printDocumentAsPdf = this.printDocumentAsPdf.bind(this);
    this.hidePdfDiv = this.hidePdfDiv.bind(this);
    this.showPdfDiv = this.showPdfDiv.bind(this);
    this.setPdfFile = this.setPdfFile.bind(this);
    this.togglePdfDiv = this.togglePdfDiv.bind(this);
    this.closePdfDiv = this.closePdfDiv.bind(this);
    this.downloadClicked = this.downloadClicked.bind(this)
    this.ocrHighlight = this.ocrHighlight.bind(this);
    this.ocrForm= this.ocrForm.bind(this);
    this.openNotification = this.openNotification.bind(this);
    this.handleTextHighlight = this.handleTextHighlight.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.handleOk1 = this.handleOk1.bind(this);
    this.handleTitleOk = this.handleTitleOk.bind(this);
    this.handleTitleCancel = this.handleTitleCancel.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCancel1 = this.handleCancel1.bind(this);
    this.initiatpdfNewProcess = this.initiatpdfNewProcess.bind(this);
    this.pdfhighlightRef = React.createRef()
    this.pdfjslibRef = React.createRef();
    this.sigPad = React.createRef();
    //  this.pdfjslibRef = React.forwardRef();
  }

  componentDidMount() {
    localStorage.setItem('PRIMARYPDFURL', '');
    const { location }: any = this.props;
    // console.log('location.state.processId', this.props.location.state.processId)
    if (this.props.location.state.documentInfo.childProcess === true) {
      this.props.getDocumentDetailV2Asyn(location.state.processId).then((res: any) => {
        // console.log('getDocumentDetailAsyn V2 => ', res)
        this.setPdfFile(res.data);

        if (res && res.data && res.data.signedPdf) {
          this.props.getIncryptedPDF(res.data.signedPdf).then((pdf_Data: any) => {

            let pdf_url: any = `${process.env.REACT_APP_SERVER_PDF_ENC_URL}/document/${res.data.signedPdf}.enc.unenc`
            let pdf_url2: any = `${process.env.REACT_APP_SERVER_PDF_ENC_URL}/document/${res.data.signedPdf}`
console.log(pdf_url,'pdf_url')
console.log(`${res.data.signedPdf}`,"pdf")
            localStorage.setItem('PRIMARYPDFURL', pdf_url);

            this.setState({ url: pdf_url2, });
          });
        }


      });

    }
    else {
      this.props.getDocumentDetailAsyn(location.state.processId).then((res: any) => {
        // console.log('getDocumentDetailAsyn =>', res)

        this.setPdfFile(res.data);
        if (res && res.data && res.data.signedPdf) {
          this.props.getIncryptedPDF(res.data.signedPdf).then((pdf_Data: any) => {

            let pdf_url: any = `${process.env.REACT_APP_SERVER_PDF_ENC_URL}/document/${res.data.signedPdf}.enc.unenc`

            localStorage.setItem('PRIMARYPDFURL', pdf_url);
            this.setState({ url: pdf_url, });
          });
        }

      });
    }
    // this.setPdfFile();
    window.addEventListener(
      "hashchange",
      this.scrollToHighlightFromHash,
      false
    );
  }

  componentWillUnmount() {
    const { location }: any = this.props;
    if (this.state.pdfInfo && this.state.pdfInfo.signedPdf && this.state.checkDrcptyPdf === false) {
      this.props.EncrptyPdfDataDelAsyn(this.state.pdfInfo.signedPdf)
    }

  }


  setPdfFile(documentDetailData: any) {
    //let seenStamp =documentDetailData?documentDetailData.documentUpdatedData.seenStamp:false;
    // let pdfUrl = documentDetailData && documentDetailData.documentUpdatedData && documentDetailData.documentUpdatedData.processTimeLogs[0] ? documentDetailData.documentUpdatedData.processTimeLogs[0].pdfFile : '';
    // console.log('Doc verify = ', documentDetailData)
    // localStorage.setItem('PRIMARYPDFURL', pdfUrl);
    this.setState({ seenStamp: documentDetailData.seenStamp, pdfInfo: documentDetailData }, () => {
      this.props.getDocumentHighlights(documentDetailData.document_UUID).then((res: any) => {
        const highlightData = this.props.documentData.filter((dt: any) => dt.coordinates && dt.coordinates.length > 0).map((dt: any) => {
          let p = JSON.parse(dt.coordinates[0]);
          let c = {
            comment: p.comment,
            content: p.content,
            position: p.position,
            id: dt.uuid
          }
          return c;
        });

        //let highlightd = JSON.parse(documentData.coordinates[0]);
        this.setState({
          highlights: highlightData.reverse(),
        });
      });
    });
  }

  // setPdfFile() { 
  //   let seenStamp =history.location.state?documentInfo.documentUpdatedData.seenStamp:false;
  //   const { location,getDocumentHighlights }:any = this.props;
  //   let pdfUrl = location.state?location.state.documentInfo.documentUpdatedData.processTimeLogs[0].pdfFile:'';
  //   console.log('Doc verify = ',location)
  //   localStorage.setItem('PRIMARYPDFURL', pdfUrl);
  //   this.setState({url:pdfUrl,seenStamp:location.state.documentInfo.seenStamp},() =>{
  //     getDocumentHighlights(location.state.documentInfo.document_UUID).then((res:any) => {
  //       const { documentData }:any = this.props;
  //       const highlightData = documentData.filter((dt: any)=>dt.coordinates && dt.coordinates.length > 0).map((dt: any) =>{
  //           let p = JSON.parse(dt.coordinates[0]);
  //           let c = {
  //             comment:p.comment,
  //             content:p.content,
  //             position:p.position,
  //             id:dt.uuid
  //           }
  //           return c;
  //       });

  //       //let highlightd = JSON.parse(documentData.coordinates[0]);
  //       this.setState({
  //         highlights: highlightData.reverse(),
  //       });
  //     });
  //   });
  // }

  callback = (key: any) => {
    // console.log(key);
  }
  // state = {
  //   url: initialUrl,
  //   highlights: testHighlights[initialUrl]
  //     ? [...testHighlights[initialUrl]]
  //     : [],
  //     esignImage:''
  // };

  resetHighlights = () => {
    this.setState({
      highlights: [],
    });
  };

  toggleDocument = () => {
    // const newUrl =
    //   this.state.url === PRIMARY_PDF_URL ? SECONDARY_PDF_URL : PRIMARY_PDF_URL;

    // this.setState({
    //   url: newUrl,
    //   highlights: testHighlights[newUrl] ? [...testHighlights[newUrl]] : [],
    // });
  };

  scrollViewerTo = (highlight: any) => { };

  scrollToHighlightFromHash = () => {
    const highlight = this.getHighlightById(parseIdFromHash());

    if (highlight) {
      this.scrollViewerTo(highlight);
    }
  };



  getHighlightById(id: string) {
    const { highlights } = this.state;

    return highlights.find((highlight) => highlight.id === id);
  }

  addHighlight(highlight: NewHighlight) {
    const { highlights } = this.state;
    // console.log("Saving highlight", highlight)
    const formData = {
      docId: this.props.documentDetailData.document_UUID,
      commentText: highlight.comment.text,
      highLightText: highlight.content.text,
      isHighLight: true,
      coordinates: JSON.stringify(highlight),

    }

    this.props.AddHighlightsAsyn(formData).then((res: any) => {
      this.props.getDocumentHighlights(this.props.documentDetailData.document_UUID).then((res: any) => {
        const highlightData = this.props.documentData.filter((dt: any) => dt.coordinates && dt.coordinates.length > 0).map((dt: any) => {
          let p = JSON.parse(dt.coordinates[0]);
          let c = {
            comment: p.comment,
            content: p.content,
            position: p.position,
            id: dt.uuid
          }
          return c;
        });

        //let highlightd = JSON.parse(documentData.coordinates[0]);
        this.setState({
          highlights: highlightData.reverse(),
        });

        getDocumentComments(this.props.documentDetailData.document_UUID);
      });
    });

    // this.setState({
    //   highlights: [{ ...highlight, id: getNextId() }, ...highlights],
    // },()=>{

    // });
  }

  updateHighlight(highlightId: string, position: Object, content: Object) {
    // console.log("Updating highlight", highlightId, position, content);

    this.setState({
      highlights: this.state.highlights.map((h) => {
        const {
          id,
          position: originalPosition,
          content: originalContent,
          ...rest
        } = h;
        return id === highlightId
          ? {
            id,
            position: { ...originalPosition, ...position },
            content: { ...originalContent, ...content },
            ...rest,
          }
          : h;
      }),
    });
  }
  elementChildren(element: any) {
    var childNodes = element.childNodes,
      children: any[] = [],
      i = childNodes.length;

    while (i--) {
      if (childNodes[i].nodeType == 1) {
        children.unshift(childNodes[i]);
      }
    }

    return children;
  }

  printDocumentAsPdf = () => {
    const input: any = document.getElementById('pdfloaderid');
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        // const pdf = new jsPDF();
        // pdf.addImage(imgData, 'JPEG', 0, 0);
        // pdf.save("download.pdf");

        var doc = new jsPDF("p", "mm", "a4");
        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();

        doc.addImage(imgData, 'JPEG', 0, 0, width, height);

        // pdf.output('dataurlnewwindow');
        doc.save("download.pdf");
      })
      ;
  }

  hidePdfDiv = () => {
    this.setState({ isShowpdfColumn: false });
  }

  showPdfDiv = () => {
    this.setState({ isShowpdfColumn: true });
  }

  togglePdfDiv = () => {
    this.setState({ isShowpdfColumn: false });
  }

  closePdfDiv = () => {
    this.setState({ isShowpdfColumn: true });
  }

  //   downloadClicked() {
  //     console.log(this.state.pdfDOc)
  //     var HTML_Width:any = $(".pdfViewer").width();
  //     var HTML_Height:any = $(".pdfViewer").height();
  //     var top_left_margin:any = 15;
  //     var PDF_Width:any = HTML_Width + (top_left_margin * 2);
  //     var PDF_Height:any = (PDF_Width * 1.5) + (top_left_margin * 2);
  //     var canvas_image_width:any = HTML_Width;
  //     var canvas_image_height:any = HTML_Height;

  //     var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

  //     html2canvas($(".pdfViewer")[0]).then(function (canvas) {
  //         var imgData:any = canvas.toDataURL("image/jpeg", 1.0);
  //         var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
  //         pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height);
  //         for (var i = 1; i <= totalPDFPages; i++) { 
  //             pdf.addPage(PDF_Width, PDF_Height);
  //             pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
  //         }
  //         pdf.save("highlightedpdfdownload.pdf");
  //        // $(".pdfViewer").hide();
  //     });
  //   //   this.state.pdfDOc.getData().then((u8:any) => {
  //   //     let blob = new Blob([u8.buffer], {
  //   //         type: 'application/pdf'
  //   //     });
  //   //     // Chrome, Safari, Firefox, Opera
  //   //     let url = URL.createObjectURL(blob);
  //   //     this.openLink(url);
  //   //     // Remove the link when done
  //   //     setTimeout(function () {
  //   //         window.URL.revokeObjectURL(url);
  //   //     }, 5000);
  //   // });
  //     // const viewer:any = this.pdfviewer;
  //     // if(viewer){
  //     //   viewer.download();
  //     // }

  // }

openNotification = () => {
    notification.open({
      message: 'Highlighted Comment Added',
      description:
        ' Click Treatedby and Comments to view.',
     
    });
  };

  handleTextHighlight = () => {


    const selection = window.getSelection();
    if (selection) {
      const selectedText = selection.toString();
      
     setTimeout(()=>{
      this.setState({highlightedText:selectedText});
      // this.addHighlight({ this.state.highlightedText , 2, "Noe This" });
   //  alert(this.state.highlightedText);


   this.setState({isTitleModalOpen:true});
  // this.setState({isModalOpen:false});
     },100);

    
   
    }

   
    // Update the state with the selected text
 
  };


  ocrForm(){

this.setState({isModal1Open:true});

  }


  ocrHighlight(x: any,y: any){

    this.setState({isModalOpen:true});
       
    let textData = {
      
      text: x,
      pgNumber: y
    
    };
    // axios.post('/api/getocr', textData)
    axios.post('/api/getocr', textData)
  .then(response => {

    if (response.status === 200) {
      this.setState({ocrLoaded:true});
      // console.log('Response:', response.data);
      let data = response.data;
      this.setState({ocrContent:data})
      console.log(data,'from OCR')
  }else{
    this.setState({ocrLoaded:true});
    // console.log('Response:', response.data);
   alert("The pdf file does not exists in the OCR Engine. It is possible this process was initiated prior to the integration of the OCR")
  }


 
    
  })
  .catch(error => {
    console.error('Error:', error);
  });


  
  }




 handleOk = () => {
  this.setState({isModalOpen:false});
  this.setState({ocrLoaded:false})
  };

  handleOk1 = () => {
    
    this.setState({ocrContent:'...kindly wait. Content Loading.'});
    this.setState({isModal1Open:false});
    this.ocrHighlight(this.props.documentDetailData.signedPdf, Number(this.state.pdfNum))
    };

    handleTitleOk = () => {

   
    
      const formData = {
        docId: this.props.documentDetailData.document_UUID,
        commentText: this.state.hgTitle,
        highLightText:this.state.highlightedText ,
        isHighLight: false,
        coordinates: JSON.stringify(0),
      
  
      }
  
      this.props.AddHighlightsAsyn(formData)
      .then((res: any)=>{

      })
      this.openNotification();
      this.setState({isTitleModalOpen:false});

     
      };

      handleTitleCancel = () => {
        this.setState({isTitleModalOpen:false});
     
        };

 handleCancel = () => {
  this.setState({isModalOpen:false});
  this.setState({ocrLoaded:false})
  };

  handleCancel1 = () => {
    this.setState({isModal1Open:false});
    };

  downloadClicked() {
    // console.log(this.state.pdfDOc)
    this.state.pdfDOc.getData().then((u8: any) => {
      let blob = new Blob([u8.buffer], {
        type: 'application/pdf'
      });
      // Chrome, Safari, Firefox, Opera
      let url = URL.createObjectURL(blob);
      this.openLink(url);
      // Remove the link when done
      setTimeout(function () {
        window.URL.revokeObjectURL(url);
      }, 5000);
    });
  }

  private openLink(url: string) {
    let a = document.createElement('a');
    // Firefox requires the link to be in the body
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = 'Document.pdf';
    a.click();
    // Remove the link when done
    document.body.removeChild(a);
  }

  handlePrint = (event: any) => {
    event.preventDefault();
    this.state.pdfDOc.getData().then((u8: any) => {
      let blob = new Blob([u8.buffer], {
        type: 'application/pdf'
      });
      // Chrome, Safari, Firefox, Opera
      let url = URL.createObjectURL(blob);
      window.open(url, "PRINT", "height=400,width=600");
      // Remove the link when done
      setTimeout(function () {
        window.URL.revokeObjectURL(url);
      }, 5000);
    });
    // this.refs.pdfhighlight.printClicked();
    //   console.log(this.pdfhighlightRef.viewer)
    //  const html: any = document.getElementById('pdfloaderid');

    // const divele : any = document.getElementsByName('PdfHighlighter');

    // window.open(divele, "PRINT", "height=400,width=600");
    // document.body.appendChild(iframe);
    // iframe.contentWindow.document.open();
    // iframe.contentWindow.document.write(html);
    // iframe.contentWindow.document.close();
    //   var doc = new jsPDF();
    // doc.html(html);
    // doc.save("myDocument.pdf");
    // html2canvas(html)
    //     .then((canvas) => {
    //       const imgData = canvas.toDataURL('image/png');
    //       // const pdf = new jsPDF();
    //       // pdf.addImage(imgData, 'JPEG', 0, 0);
    //       // pdf.save("download.pdf");

    //       //var doc = new jsPDF("p", "mm", "a4");
    //       const doc = new jsPDF();
    //       var width = doc.internal.pageSize.getWidth();
    //       var height = doc.internal.pageSize.getHeight();

    //       doc.addImage(imgData, 'JPEG', 0, 0, width, height);

    //       // pdf.output('dataurlnewwindow');
    //       doc.save("download.pdf");
    //     })
    //   ;
    // window.open(this.state.pdfDOc, "PRINT", "height=400,width=600");
  };

  proceedBySigning() {

    const { location, getDocumentHighlights }: any = this.props;
    //let processId = this.props.documentDetailData.documentUpdatedData.processId;
    const processId = this.state.pdfInfo.documentUpdatedData.processId;
    this.props.history.push({
      pathname: '/document-signin',
      state: { documentInfo: this.state.pdfInfo, processId: processId }
      // state: { documentInfo:location.state.documentInfo,processId:processId }
      // search: '?query=abc',
      // state: { documentInfo:documentInfo }
    });
    // const historyBrowser = createBrowserHistory({
    //   //basename: process.env.PUBLIC_URL,
    //   forceRefresh: false,
    // });
    // historyBrowser.push({
    //   pathname: '/document-signin',
    //   state: { documentInfo:location.state.documentInfo}
    //   });
    //historyBrowser.push('/document-signin', { documentInfo:documentInfo });
    // history.push({
    //   pathname: '/document-signin',
    //   // search: '?query=abc',
    //   state: { documentInfo:documentInfo }
    // });
  }

  initiatpdfNewProcess() {
    // console.log('pdfInfo',this.state.pdfInfo)
    // console.log('docid',this.state.pdfInfo.documentUpdatedData._id)
    this.setState({ checkDrcptyPdf: true, btnDisable: true, isLoading: true });
    const documentId = this.state.pdfInfo.documentUpdatedData._id;
    this.props.pdfNewProcessAsyn(documentId).then((res: any) => {
      this.props.history.push({
        pathname: '/use-this-document',
        // search: '?query=abc',
        state: { documentId: documentId, processId: res.data.processId, createdAt: res.data.createdAt }
      });

    })


  }

  handleEditButton = () => {
    // /document-editor
    const { location }: any = this.props;
    // console.log('location.state.processId', this.props.location.state.processId)
    this.props.history.push({
      pathname: '/document-editor',
      // search: '?query=abc',
      state: { documentInfo: this.state.pdfInfo, processId: this.props.location.state.processId }
    });
  }

  goBack = () => {
    this.props.history.goBack();
  };

  // getOnLoadPageNumbers = async () => {
  //   var loadingTask = await pdfjs.getDocument('http://localhost:3000/document/1641978097144.pdf');
  //   loadingTask.promise.then(function (pdf) {
  //     console.log("pdfdata => ", pdf.numPages);

  //   }, function (reason) {
  //     console.error("reason=> ", reason);
  //   });
  // }



  render() {
    const { url, highlights } = this.state;
    const { location, user }: any = this.props;
    let documentTitle = this.props.documentDetailData ? this.props.documentDetailData.processName : 'New Document Process';

    // test docs
    console.log(this.props.documentDetailData,"Document Details");

    const isStartNewProcess = location.state ? location.state.viewDocument : null;
    const isChildProcessTrue =
      this.props.location && this.props.location.state && this.props.location.state.documentInfo && this.props.location.state.documentInfo.childProcess === true ? false : true;
    const isConcurrentProcessAlreadyInitiated = this.props.location && this.props.location.state && this.props.location.state.documentInfo && this.props.location.state.documentInfo.concurrentProcessAlreadyInitiated === true ? true : false;

    const isUserInProcess = this.props.location && this.props.location.state && this.props.location.state.documentInfo && this.props.location.state.documentInfo.userInProcess === true ? true : false;
    const isUserAlreadySigned = this.props.location && this.props.location.state && this.props.location.state.documentInfo && this.props.location.state.documentInfo.userAlreadySigned === true ? true : false;
    // console.log("isUserInProcess ", this.props.location.state)
    // console.log("isUserAlreadySigned ", this.props.location.state.documentInfo.userAlreadySigned)
    // console.log('documentData');
    // const { documentData }:any = this.props;
    // console.log(documentData);
    return (
      <Container>
        <Spin indicator={antIcon} style={{ alignItems: 'center', justifyContent: 'center', justifyItems: 'center', textAlign: 'center', width: '100%', maxHeight: '100%', position: 'fixed', zIndex: 1111, }} spinning={this.state.isLoading} />
        <div className="site-layout-content"
          style={{ marginTop: 0, paddingTop: 0 }}
        //  style={{marginTop:5}}
        >
          {/* <div style={{ padding: '16px 100px 24px 24px'}}> */}
          <div >
            {/* <Row>
               <Col span={15} >
               <Button style={{marginTop:10,float:'right',marginBottom:15}} onClick={() => this.printDocumentAsPdf()}><DownloadOutlined/></Button>
               </Col>
               <Col span={9}></Col>
           </Row> */}
            {/* <h2 style={{paddingTop:10,paddingBottom:10,backgroundColor:"#fff",marginTop:20}}>Requirement Application Form bill Johnson</h2> */}
            <Row style={{ width: '100%', height: '100%', paddingTop: 0, paddingBottom: 5 }} >
              {this.state.isShowpdfColumn &&
                <Col span={15}>
                  <Row style={{ width: '100%', maxWidth: '100%' }}>
                    <Col span={user.userType == 'CHD' || user.userType == 'Clerk' || user.userType == "DD's & AD's" ? 15 : 23}>
                      {/* <h2 className="color-ffffff text-capitalize">{documentTitle}</h2> */}
                      <h2 className="color-ffffff text-capitalize">{localStorage.getItem("DOCREF")}</h2>
                    </Col>
                    {user.userType == 'CHD' ? (
                      ability.can('CHDPermission', 'initiateAdHocProcess') && <>
                        {/* {user.userType == 'CHD' && isStartNewProcess && isChildProcessTrue && isConcurrentProcessAlreadyInitiated === false && */}
                        {isStartNewProcess && isChildProcessTrue && isConcurrentProcessAlreadyInitiated === false &&
                          <Col span={8}>
                            {/* <Button type="primary" title={this.state.btnDisable ? 'Please wait..' : 'Start new process'} disabled={this.state.btnDisable} onClick={() => this.initiatpdfNewProcess()} ghost>
                              Use this PDF to start new process
                            </Button> */}
                          </Col>
                        }
                      </>

                    )
                      :

                      (isStartNewProcess && isChildProcessTrue && isConcurrentProcessAlreadyInitiated === false &&
                        <Col span={8}>
                          {/* <Button type="primary" title={this.state.btnDisable ? 'Please wait..' : 'Start new process'} disabled={this.state.btnDisable} onClick={() => this.initiatpdfNewProcess()} ghost>
                            Use this PDF to start new process
                          </Button> */}
                        </Col>
                      )


                    }
                    <Col span={1}></Col>
                  </Row>
                </Col>
              }
              <Col span={1}></Col>
              <Col span={this.state.isShowpdfColumn ? 8 : 23}>
                <Row>



                  <Col >
                  <Space>

                 <Modal title="Add Highlighted Text To Comments" visible={this.state.isTitleModalOpen} onOk={this.handleTitleOk} onCancel={this.handleTitleCancel} >
                 <Tooltip title="Your highlited Text would be seen on the right tab, under TreatedBy and Comments">
                
                   <label>Title of your highlighted texts </label>
                    <input type="text" onChange={(e) =>  this.setState({hgTitle: e.target.value})} value={this.state.hgTitle} />
                    </Tooltip>
                    </Modal>


                 
                  </Space>
                  <Space>
                      
                   </Space>
                   <Modal title="PDF OCR Form" visible={this.state.isModal1Open} onOk={this.handleOk1} onCancel={this.handleCancel1} >
                   <label>Page number to extract text from </label>
                    <input type="number"  onChange={(e) => this.setState({pdfNum: e.target.value})} value={this.state.pdfNum}/>
                    </Modal>

                   
                   
                   <Modal title="OCR/Highlight" visible={this.state.isModalOpen} onOk={this.handleOk} onCancel={this.handleCancel} >
{/*                   
                   <Tooltip title="prompt text">
   <input type="text" />
  </Tooltip> */}
 <Tooltip title="Hightlight texts to add to the process comments">
 <TextArea rows={14}
                     onMouseUp={this.handleTextHighlight}
                   style={{ backgroundColor: "#fff"}}
                      readOnly 
                      className="formInput"
                       value={this.state.ocrContent} />
  </Tooltip>
  
             
                        
                   {/* <div dangerouslySetInnerHTML={{ __html: this.state.ocrContent }} /> */}
        <p>
        {this.state.ocrLoaded==false &&   <Spin />}
        </p>
      
      </Modal>
                   </Col>
                  <Col span={18}>
                  
                    <Space>
                    <Button onClick={this.ocrForm} style={{ borderColor: "#C1C1C1" }} type="primary" ghost><span style={{ color: 'inherit' }}>OCR</span></Button>
                      <Button onClick={this.downloadClicked} style={{ borderColor: "#C1C1C1" }} type="primary" icon={<DownloadOutlined />} ghost><span style={{ color: 'inherit' }}>Download</span></Button>
                      {ability.can('clerkPermission', 'printDocument') ? <Button onClick={this.handlePrint} style={{ borderColor: "#C1C1C1" }} type={'primary'} icon={<PrinterOutlined />} ghost><span style={{ color: 'inherit' }}>Print</span></Button>
                        : ability.can('CHDPermission', 'printDocument') ? <Button onClick={this.handlePrint} style={{ borderColor: "#C1C1C1" }} type={'primary'} icon={<PrinterOutlined />} ghost><span style={{ color: 'inherit' }}>Print</span></Button>
                          : ability.can('DDsAndADPermission', 'printDocument') ? <Button onClick={this.handlePrint} style={{ borderColor: "#C1C1C1" }} type={'primary'} icon={<PrinterOutlined />} ghost><span style={{ color: 'inherit' }}>Print</span></Button>
                            : <></>}
                      {user.userType !== 'admin' && <Button onClick={this.handleEditButton} style={{ borderColor: "#C1C1C1" }} type={'primary'} icon={<EditOutlined />} ghost><span style={{ color: 'inherit' }}>Edit</span></Button>}
                    </Space>
                  </Col>
                  <Col span={6} style={{ textAlign: 'right' }}>
                    <Space >
                      <Button type="link" className="document-varification-btn-zoom" onClick={() => this.togglePdfDiv()} ghost> <Image preview={false} width={20} src={'./images/window-expand.png'} /></Button>
                      <Button type="link" className="document-varification-btn-close" onClick={() => this.closePdfDiv()} style={{ color: '#000', fontSize: 20, fontWeight: 'bold', padding: 0, marginTop: -2 }} ghost><CloseOutlined /></Button>
                    </Space>
                  </Col>
                </Row>



              </Col>
            </Row>
            <div className="App boxshadowclass" style={{ display: "flex", height: "100vh", backgroundColor: '#DFE0EB' }}>
              {/* <Sidebar
          highlights={highlights}
          resetHighlights={this.resetHighlights}
          toggleDocument={this.toggleDocument}
        /> */}
              {/* <Row  style={{width:'100%',height:'100%'}} >
         {this.state.isShowpdfColumn &&
         <Col span={15}></Col>
         }
         <Col span={1}></Col>
         <Col span={this.state.isShowpdfColumn?8:23}>
         <Space>
          <Button type="primary" icon={<DownloadOutlined/>} ghost>Download</Button>
          <Button type={'primary'} icon={<PrinterOutlined/>} ghost>Print</Button>
          </Space>
         </Col>
         </Row> */}
              <Row style={{ width: '100%', height: '100%' }} >
                {this.state.isShowpdfColumn &&
                  <Col span={15}>
                    {/* Pdf loader start */}
                    <div
                      id="pdfloaderid"
                      style={{
                        height: "100vh",
                        // width: "75vw",
                        // width: "60vw",
                        width: "100%",
                        position: "relative",
                        marginRight: 40
                      }}
                    >
                      <PdfLoader url={url} beforeLoad={<Spinner />}>
                        {(pdfDocument) => (
                          <PdfHighlighter
                            ref={(ref) => this.pdfhighlightRef = ref}
                            pdfDocument={pdfDocument}
                            enableAreaSelection={(event) => event.altKey}
                            onScrollChange={resetHash}
                            // pdfScaleValue="page-width"
                            scrollRef={(scrollTo) => {
                              this.scrollViewerTo = scrollTo;
                              this.scrollToHighlightFromHash();
                              this.setState({ pdfDOc: pdfDocument });
                            }}
                            onSelectionFinished={(
                              position,
                              content,
                              hideTipAndSelection,
                              transformSelection
                            ) => (
                              <Tip
                                onOpen={transformSelection}
                                onConfirm={(comment) => {
                                  this.addHighlight({ content, position, comment });

                                  hideTipAndSelection();
                                }}
                              />
                            )}
                            highlightTransform={(
                              highlight,
                              index,
                              setTip,
                              hideTip,
                              viewportToScaled,
                              screenshot,
                              isScrolledTo
                            ) => {
                              const isTextHighlight = !Boolean(
                                highlight.content && highlight.content.image
                              );

                              const component = isTextHighlight ? (
                                <Highlight
                                  isScrolledTo={isScrolledTo}
                                  position={highlight.position}
                                  comment={highlight.comment}
                                />
                              ) : (
                                <AreaHighlight
                                  isScrolledTo={isScrolledTo}
                                  highlight={highlight}
                                  onChange={(boundingRect) => {
                                    this.updateHighlight(
                                      highlight.id,
                                      { boundingRect: viewportToScaled(boundingRect) },
                                      { image: screenshot(boundingRect) }
                                    );
                                  }}
                                />
                              );

                              return (
                                <Popup
                                  popupContent={<HighlightPopup {...highlight} />}
                                  onMouseOver={(popupContent) =>
                                    setTip(highlight, (highlight) => popupContent)
                                  }
                                  onMouseOut={hideTip}
                                  key={index}
                                  children={component}
                                />
                              );
                            }}
                            highlights={highlights}
                          />
                        )}
                      </PdfLoader>
                      <div style={{ width: 200, height: 200, visibility: 'hidden' }} ><img id="simage" src={this.state.esignImage} style={{ width: '100%', height: '100%', visibility: 'hidden' }} /></div>
                    </div>
                  </Col>
                }

                <Col span={1}>
                  {this.state.isShowpdfColumn
                    ? <Button type="link" style={{ flex: 1, top: '50%', color: '#000' }} icon={<LeftOutlined />} onClick={() => this.hidePdfDiv()}></Button>
                    : <Button type="link" style={{ flex: 1, top: '50%', color: '#000' }} icon={<RightOutlined />} onClick={() => this.showPdfDiv()}></Button>
                  }

                </Col>
                <Col span={this.state.isShowpdfColumn ? 8 : 23} style={{ height: '100%' }}>
                  <Sidebar
                    highlights={highlights}
                    resetHighlights={this.resetHighlights}
                    toggleDocument={this.toggleDocument}
                    seenStamp={this.state.seenStamp}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <Row
          className="proceedClass"
            style={{
              padding: '16px 0px 24px 0px',
              // borderLeft: "1px solid #dfe0eb",
              // borderRight: "1px solid #dfe0eb",
              // borderBottom: "1px solid #dfe0eb",
            }}
          >
            <Col span="16" >
              <Button onClick={() => this.goBack()} type="primary" size="middle" style={{ marginRight: "10px" }} ghost>
                Back
              </Button>
            </Col>
            <Col span="8" style={{ textAlign: "right" }}>

              <Link to="/dashboard">
                <Button type="primary" size="middle" style={{ marginRight: "10px" }} ghost>
                  Cancel
                </Button>
              </Link>

              {isUserInProcess && isUserAlreadySigned === false &&
                <Button onClick={() => this.proceedBySigning()} type="primary" size="middle" ghost>
                  Proceed by Signing
                </Button>
              }
            </Col>
          </Row>
          {/* <Row style={{ marginTop: 125, marginBottom: 125 }}><Col span={24}></Col></Row> */}

        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    documentData: state.documenthighlights.documentData,
    documentDetailData: state.documenthighlights.documentDetailData,
    user: state.auth.user,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getDocumentHighlights: (data: any) => dispatch(getDocumentHighlights(data)),
    getOcr: (data: any) => dispatch( getOcr(data)),
    getDocumentComments: (data: any) => dispatch(getDocumentComments(data)),
    AddHighlightsAsyn: (data: any) => dispatch(AddHighlightsAsyn(data)),
    getIncryptedPDF: (data: any) => dispatch(getIncryptedPDF(data)),
    EncrptyPdfDataDelAsyn: (data: any) => dispatch(EncrptyPdfDataDelAsyn(data)),
    ClearAddHighlightState: () => dispatch(ClearAddHighlightState()),
    getDocumentDetailAsyn: (data: any) => dispatch(getDocumentDetailAsyn(data)),
    getDocumentDetailV2Asyn: (data: any) => dispatch(getDocumentDetailV2Asyn(data)),
    unsetDocumentDetailStateAsync: () => dispatch(unsetDocumentDetailStateAsync()),
    pdfNewProcessAsyn: (data: any) => dispatch(pdfNewProcessAsyn(data)),
  }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DocumentVerification))
// export default DocumentVerification;
